package ui.external.materialui

object TextFieldVariant {
    const val filled = "filled"
    const val outlined = "outlined"
}
